import { sortBy } from 'lodash-es';
import { pathgen } from 'object-path-generator';
export let EnhancedAutocompleteOptionType = /*#__PURE__*/function (EnhancedAutocompleteOptionType) {
  EnhancedAutocompleteOptionType["Item"] = "item";
  EnhancedAutocompleteOptionType["EmptySearch"] = "empty-search";
  EnhancedAutocompleteOptionType["IncompleteSearch"] = "incomplete-search";
  return EnhancedAutocompleteOptionType;
}({});
export const EnhancedAutocompleteTestIds = pathgen('EnhancedAutocompleteTestIds');
export const mapDataToOption = (data, keyField, labelField) => ({
  value: data[keyField],
  label: data[labelField],
  data,
  type: EnhancedAutocompleteOptionType.Item
});
export const getOptions = (options, keyField, labelField) => {
  const mappedOptions = options.map(item => mapDataToOption(item, keyField, labelField));
  return sortBy(mappedOptions, option => option.label.toLowerCase());
};